import { render, staticRenderFns } from "./PhotosSourceLocationsSettings.vue?vue&type=template&id=bf1bfc0a&scoped=true"
import script from "./PhotosSourceLocationsSettings.vue?vue&type=script&lang=js"
export * from "./PhotosSourceLocationsSettings.vue?vue&type=script&lang=js"
import style0 from "./PhotosSourceLocationsSettings.vue?vue&type=style&index=0&id=bf1bfc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1bfc0a",
  null
  
)

export default component.exports